'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.device_index', {
    url: '/company/:company_id/device_index?target&value',
    template: '<oem-device-index></oem-device-index>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/index/device_index.routes.js